import { render, staticRenderFns } from "./DeepCustomerEmpathy2.vue?vue&type=template&id=639b9b96&scoped=true&"
import script from "./DeepCustomerEmpathy2.vue?vue&type=script&lang=js&"
export * from "./DeepCustomerEmpathy2.vue?vue&type=script&lang=js&"
import style0 from "./DeepCustomerEmpathy2.vue?vue&type=style&index=0&id=639b9b96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b9b96",
  null
  
)

export default component.exports